import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { branch, renderNothing } from 'recompose'
import { compose } from 'redux'
import {
  activitySelector,
  activityShowingSelector
} from '../../store/selectors/activitySelectors'
import { userIdSelector } from '../../store/selectors/baseSelectors'
import { toggleActivity } from '../../store/actions/activity'
import populates from '../../store/populates'
import { sidebarShowingSelector } from '../../store/selectors/sidebarSelectors';

const ActivityContainer = compose(
  connect(
    state => ({
      show: activityShowingSelector(state),
      sidebarShowing: sidebarShowingSelector(state),
      userId: userIdSelector(state),
      activity: activitySelector(state)
    }),
    { toggleActivity }
  ),
  branch(({ show }) => !show, renderNothing),
  firebaseConnect(({ userId }) => {
    if (userId) {
      return [
        {
          path: `/activity/feeds/${userId}/feed`,
          queryParams: ['orderByChild=date&limitToLast=100'],
          populates: [populates.userName, populates.boardName]
        }
      ]
    }
  })
)

export default ActivityContainer
